let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("7v6wU"), load("b544F"), load("a8heY"), load("9PPH7"), load("hrf1M")]).then(() => parcelRequire('g0MkC'));